{
  "Can i translate this ?": "هل يمكنني ترجمة هذا؟",
  "Accounts": "الحسابات المتصلة",
  "Site settings": "إعدادات الموقع",
  "Language": "لغة",
  "Enable Marmaid": "تمكين حورية البحر",
  "Enable Blur": "تمكين التعتيم",
  "Enable Animations": "تفعيل الرسوم المتحركة",
  "Personal information": "معلومات شخصية",
  "NO": "لا",
  "YES": "نعم",
  "General": "عام",
  "Profile": "الملف الشخصي",
  "Notifications": "إشعارات",
  "Identity": "هوية",
  "Tokens": "الرموز",
  "Instances": "مثيلات",
  "Domains": "المجالات",
  "Sessions": "الجلسات",
  "My Sessions": "جلساتي",
  "No projects": "لا توجد مشاريع",
  "Create project": "أنشئ مشروعًا",
  "Projects": "المشاريع",
  "Project name": "اسم المشروع",
  "Project description": "وصف المشروع",
  "Select team": "اختر فريق",
  "Set unique description for project": "حدد وصفًا فريدًا للمشروع",
  "Please fill out this field.": "الرجاء ملء هذه الخانة.",
  "Create": "خلق",
  "OwnedBy": "مملوكة بواسطة",
  "Open": "فتح",
  "Settings": "إعدادات",
  "Apps": "تطبيقات",
  "Logout": "تسجيل خروج",
  "Admin": "مسؤل",
  "Iot": "Iot",
  "Name": "اسم",
  "Email": "بريد إلكتروني",
  "You have being mentioned inside": "لقد تم ذكرك في الداخل",
  "from project": "من المشروع",
  "by": "بواسطة",
  "You have being invited as member inside project": "لقد تمت دعوتك كعضو داخل المشروع",
  "to build awesome things": "لبناء أشياء رائعة"
}